import React from 'react'
import CyberGeneralInfoCard from './CyberGeneralInfoCard'
import WorkspaceKeyPointOfContactsCard from './WorkspaceKeyPointOfContactsCard'
import WorkspaceRelatedDocumentsCard from './WorkspaceRelatedDocumentsCard'
import { useSelector } from 'react-redux'

const WorkspaceCyberOverview = () => {
    const { workspaceOverview } = useSelector((state: any) => state.workspaces);
    if(!workspaceOverview) return (
        <p>Loading ...</p>
    )
    return (
        <div className="motif-row gap-0">
            {workspaceOverview?.generalInfo && (
                <div className="flex flex-col motif-col-md-4 motif-col-lg-6">
                    <CyberGeneralInfoCard info={workspaceOverview?.generalInfo} />
                </div>
            )}
            {/* {
                workspaceOverview?.peopleOfContact && (
                    <div className="flex flex-col motif-col-md-4 motif-col-lg-6">
                        <WorkspaceKeyPointOfContactsCard info={workspaceOverview?.peopleOfContact} />
                    </div>
                )
            } */}
            {
                workspaceOverview?.relatedDocuments && (
                    <div className="flex flex-col motif-col-md-4 motif-col-lg-6 mt-8">
                        <WorkspaceRelatedDocumentsCard info={workspaceOverview?.relatedDocuments} />
                    </div>
                )
            }
        </div>
    )
}

export default WorkspaceCyberOverview